module.exports = __webpack_public_path__ + "assets/img/00003.f726a3e8.png";